import Script from "next/script";

import type { ExternalWidgetFareharbor as ExternalWidgetFareharborType } from "../../types/ExternalWidget";

export type ExternalWidgetFareharborContentProps = Omit<ExternalWidgetFareharborType, "__typename">;

export function ExternalWidgetFareharborContent({ itemId, flowId, slug }: ExternalWidgetFareharborContentProps) {
    const url = new URL(`https://fareharbor.com/embeds/book/${slug}/items/${itemId}/?full-items=yes`);

    url.searchParams.set("flow", String(flowId));

    return <Script id={"external-widget-fareharbor"} src="https://fareharbor.com/embeds/api/v1/?autolightframe=yes" />;
}
